import ADD from "./addNote";
import { GrAdd } from "react-icons/gr";
import { useState } from "react";
export default function Sidebar() {
  const colors = [
    { id: 0, bgColor: "#fec971" },
    { id: 1, bgColor: "#fe9b72" },
    { id: 2, bgColor: "#b693fd" },
    { id: 3, bgColor: "#00d4fe" },
    { id: 4, bgColor: "#e4ef90" }
  ];
  const [value, setValue] = useState(false);
  return (
    <div className="sidebar">
      <div style={{ paddingTop: "2rem", fontWeight: "bold" }}>Docket</div>
      <div className="addComponent">
        <button
          className="add"
          style={{ transform: value ? "rotate(45deg)" : "" }}
          onClick={() => {
            setValue((prev) => !prev);
          }}
        >
          <GrAdd />
        </button>
        {value && (
          <div className="colors">
            {colors.map((color) => {
              return <ADD color={color.bgColor} />;
            })}
          </div>
        )}
      </div>
    </div>
  );
}
